<template>
  <div
    class="fixed-bottom customer-list"
    :style="!isOpen ? closePosition : null"
  >
    <q-input
      dense
      rounded
      outlined
      :disable="selectedIdx >= 0"
      v-model="search.keyword"
      bg-color="white"
      color="white"
      placeholder="Search customer"
      style="max-width: 400px; margin: 0 10px 10px 10px"
      ><template v-slot:prepend>
        <q-icon name="person_search" color="gray-10" /> </template
    ></q-input>
    
    <q-scroll-area
      horizontal
      visible
      class="customer-list-size row"
      :thumb-style="thumbStyle"
      :bar-style="barStyle"
    >
      <div>
        <div class="row no-wrap" v-if="filteredCustomer.length > 0">
          <div
            v-for="(item, index) in filteredCustomer"
            :key="index"
            class="customer"
            @click="onTabCustomerCard(index)"
          >
            <!-- Customer card here-->
            <customer-card
              :customer="item"
              :selected="index == selectedIdx ? true : false"
            ></customer-card>
          </div>
        </div>
        <!-- <q-btn v-else flat icon="person_add" @click="onAddCustomer"
          >Add customer</q-btn
        > -->
      </div>
    </q-scroll-area>

    <q-scroll-area
      style="height: 200px; padding-top: 20px; padding: 10px"
      v-if="selectedIdx >= 0"
    >
      <div class="row">
        <BasketItem
          v-for="(product, index) in mockupInfo"
          :key="index"
          :product="product"
        />
      </div>
      <!-- <div
        class="row col justify-between bg-info"
        style="padding: 0 10px; max-width; margin-bottom: 10px"
        v-for="(item, index) in mockupInfo"
        :key="index"
      >
        <div class="col-10">
          <div class="row" style="font-size: 1.3em">
            {{ item.hema_name_en }}
          </div>
          <div class="row">{{ item.hema_brand_en }}</div>
        </div>
        <div class="col-2">x999</div>
      </div> -->
    </q-scroll-area>
    <div class="col-12 row justify-end">
      <q-btn v-if="selectedIdx >= 0" flat icon="shopping_cart" @click="onCart"
        >Go to cart</q-btn
      >
    </div>
    <div
      v-if="isOpen"
      :class="isOpen ? `ctrl-btn-refresh bg-light` : `ctrl-btn`"
    >
      <i @click="onReload" class="fas fa-sync-alt ctrl-icon-plus"></i>
    </div>
    <div v-if="isOpen" :class="isOpen ? `ctrl-btn-plus bg-light` : `ctrl-btn`">
      <i @click="onAddCustomer" class="fas fa-plus ctrl-icon-plus"></i>
    </div>
    <div :class="isOpen ? `ctrl-btn bg-light` : `ctrl-btn`">
      <i @click="iconHandler" :class="iconType"></i>
    </div>
    <q-dialog v-model="addCustomerDialog.show" persistent>
      <add-customer-dialog 
        @confirmAddCustomer="onAddCustomerToList($event)"
        @addCustomerWithForm="onAddCustomerWithForm($event)"
      />
    </q-dialog>
  </div>
</template>

<script>
import { QScrollArea } from "quasar";
import { mapState } from "vuex";

export default {
  name: "CustomerList",
  components: {
    QScrollArea,
    CustomerCard: () => import("./CustomerCard.vue"),
    BasketItem: () => import("./BasketItem.vue"),
    AddCustomerDialog: () => import("@/ui/components/AddCustomerDialog.vue"),
    // CartItem: () => import("@/ui/pages/Cart/CartItem.vue"),
  },
  data() {
    return {
      selectedIdx: -1,
      addCustomerDialog: {
        show: false,
      },
      // mockupCustomerList: [
      //   {
      //     name: "Customer Test01",
      //   },
      //   {
      //     name: "Customer Test02",
      //   },
      //   {
      //     name: "Customer Test03",
      //   },
      //   {
      //     name: "Customer Test04",
      //   },
      // ],
      search: {
        keyword: null,
      },
      mockupInfo: [
        {
          cprcode: 97323,
          iprcode: 97323,
          psqty: 1,
          pr_country_en: "",
          online_category_l1_en: "Delicatessen & Eggs",
          online_category_l2_en: "Ham Bacon & Sausage",
          online_category_l3_en: "Chicken & Poultry",
          hema_brand_en: "The Gastro",
          hema_sizedesc: "1Pc",
          hema_name_en: "Roasted Premium Turkey 18Lbs",
          hema_name_th: "ROASTED TURKEY 20 LBS.",
          pr_use_original_img: false,
          avail_store: {
            1000: {
              visibility: true,
            },
            1001: {
              visibility: true,
            },
            1003: {
              visibility: true,
            },
            1005: {
              visibility: true,
            },
            1006: {
              visibility: true,
            },
            1007: {
              visibility: true,
            },
            1011: {
              visibility: true,
            },
            1012: {
              visibility: true,
            },
            1014: {
              visibility: true,
            },
            1015: {
              visibility: true,
            },
            1016: {
              visibility: true,
            },
            1017: {
              visibility: true,
            },
            1019: {
              visibility: true,
            },
            1020: {
              visibility: true,
            },
            1021: {
              visibility: true,
            },
            1022: {
              visibility: true,
            },
            1023: {
              visibility: true,
            },
            1024: {
              visibility: true,
            },
            1026: {
              visibility: true,
            },
            1030: {
              visibility: true,
            },
            1032: {
              visibility: true,
            },
            1033: {
              visibility: true,
            },
            1034: {
              visibility: true,
            },
            1036: {
              visibility: true,
            },
            1038: {
              visibility: true,
            },
            1039: {
              visibility: true,
            },
            1040: {
              visibility: true,
            },
            1041: {
              visibility: true,
            },
            1042: {
              visibility: true,
            },
            1044: {
              visibility: true,
            },
            1046: {
              visibility: true,
            },
            1047: {
              visibility: true,
            },
            1048: {
              visibility: true,
            },
            1049: {
              visibility: true,
            },
          },
          badge: {
            left: "https://group2-image-bucket-dev.s3-ap-southeast-1.amazonaws.com/9000000002/9000000002-1.png",
            right: null,
          },
          stock: 500,
          oos: 0,
          price: 6500,
          quantity: 1,
          selected: true,
        },
        {
          cprcode: 97323,
          iprcode: 97323,
          psqty: 1,
          pr_country_en: "",
          online_category_l1_en: "Delicatessen & Eggs",
          online_category_l2_en: "Ham Bacon & Sausage",
          online_category_l3_en: "Chicken & Poultry",
          hema_brand_en: "The Gastro",
          hema_sizedesc: "1Pc",
          hema_name_en: "Roasted Premium Turkey 18Lbs",
          hema_name_th: "ROASTED TURKEY 20 LBS.",
          pr_use_original_img: false,
          avail_store: {
            1000: {
              visibility: true,
            },
            1001: {
              visibility: true,
            },
            1003: {
              visibility: true,
            },
            1005: {
              visibility: true,
            },
            1006: {
              visibility: true,
            },
            1007: {
              visibility: true,
            },
            1011: {
              visibility: true,
            },
            1012: {
              visibility: true,
            },
            1014: {
              visibility: true,
            },
            1015: {
              visibility: true,
            },
            1016: {
              visibility: true,
            },
            1017: {
              visibility: true,
            },
            1019: {
              visibility: true,
            },
            1020: {
              visibility: true,
            },
            1021: {
              visibility: true,
            },
            1022: {
              visibility: true,
            },
            1023: {
              visibility: true,
            },
            1024: {
              visibility: true,
            },
            1026: {
              visibility: true,
            },
            1030: {
              visibility: true,
            },
            1032: {
              visibility: true,
            },
            1033: {
              visibility: true,
            },
            1034: {
              visibility: true,
            },
            1036: {
              visibility: true,
            },
            1038: {
              visibility: true,
            },
            1039: {
              visibility: true,
            },
            1040: {
              visibility: true,
            },
            1041: {
              visibility: true,
            },
            1042: {
              visibility: true,
            },
            1044: {
              visibility: true,
            },
            1046: {
              visibility: true,
            },
            1047: {
              visibility: true,
            },
            1048: {
              visibility: true,
            },
            1049: {
              visibility: true,
            },
          },
          badge: {
            left: "https://group2-image-bucket-dev.s3-ap-southeast-1.amazonaws.com/9000000002/9000000002-1.png",
            right: null,
          },
          stock: 500,
          oos: 0,
          price: 6500,
          quantity: 1,
          selected: true,
        },
        {
          cprcode: 1613,
          iprcode: 1613,
          psqty: 1,
          pr_country_en: "",
          online_category_l1_en: "Confectionery & Snacks",
          online_category_l2_en: "Chocolate",
          online_category_l3_en: "Bars",
          hema_brand_en: "M&M's",
          hema_sizedesc: "40g",
          hema_name_en: "Plain",
          hema_name_th: "Plain",
          pr_use_original_img: false,
          avail_store: {
            1000: {
              visibility: true,
            },
            1003: {
              visibility: true,
            },
            1012: {
              visibility: true,
            },
            1014: {
              visibility: true,
            },
            1015: {
              visibility: true,
            },
            1016: {
              visibility: true,
            },
            1019: {
              visibility: true,
            },
            1021: {
              visibility: true,
            },
            1022: {
              visibility: true,
            },
            1023: {
              visibility: true,
            },
            1024: {
              visibility: true,
            },
            1026: {
              visibility: true,
            },
            1032: {
              visibility: true,
            },
            1034: {
              visibility: true,
            },
            1038: {
              visibility: true,
            },
            1039: {
              visibility: true,
            },
            1040: {
              visibility: true,
            },
            1041: {
              visibility: true,
            },
            1044: {
              visibility: true,
            },
            1047: {
              visibility: true,
            },
            1048: {
              visibility: true,
            },
            1049: {
              visibility: true,
            },
          },
          stock: 70,
          oos: 0,
          price: 19,
          lastPrice: 25,
          quantity: 3,
          selected: true,
        },
        {
          cprcode: 187448,
          iprcode: 187448,
          psqty: 1,
          pr_country_en: "",
          online_category_l1_en: "Seasonal Hampers & Flowers",
          online_category_l2_en: "Christmas",
          online_category_l3_en: "Trees",
          hema_brand_en: "Nordmann Fir",
          hema_sizedesc: "1Pc",
          hema_name_en: "Real French Christmas Tree 1-1.25m",
          hema_name_th: "CHRISTMAS TREE 1.7-2.2M.",
          pr_use_original_img: false,
          avail_store: {
            1000: {
              visibility: true,
            },
            1003: {
              visibility: true,
            },
            1012: {
              visibility: true,
            },
            1014: {
              visibility: true,
            },
            1015: {
              visibility: true,
            },
            1016: {
              visibility: true,
            },
            1019: {
              visibility: true,
            },
            1021: {
              visibility: true,
            },
            1022: {
              visibility: true,
            },
            1023: {
              visibility: true,
            },
            1024: {
              visibility: true,
            },
            1026: {
              visibility: true,
            },
            1032: {
              visibility: true,
            },
            1034: {
              visibility: true,
            },
            1038: {
              visibility: true,
            },
            1039: {
              visibility: true,
            },
            1040: {
              visibility: true,
            },
            1041: {
              visibility: true,
            },
            1047: {
              visibility: true,
            },
            1048: {
              visibility: true,
            },
            1049: {
              visibility: true,
            },
          },
          badge: {
            left: "https://group2-image-bucket-dev.s3-ap-southeast-1.amazonaws.com/9000000002/9000000002-1.png",
            right: null,
          },
          stock: 50,
          oos: 0,
          price: 8900,
          quantity: 1,
          selected: true,
        },
      ],
      thumbStyle: {
        right: "4px",
        borderRadius: "10px",
        backgroundColor: "white",
        width: "5px",
        height: "6px",
        opacity: 1,
      },
      barStyle: {
        right: "2px",
        borderRadius: "9px",
        backgroundColor: "white",
        width: "9px",
        opacity: 0,
      },
      isOpen: false,
    };
  },
  computed: {
    ...mapState({
      customers: (state) => state["sale"]["customers"],
    }),
    iconType() {
      if (this.isOpen) {
        return "fas fa-angle-down ctrl-icon";
      } else {
        return "fas fa-angle-up ctrl-icon";
      }
    },
    closePosition() {
      return this.selectedIdx >= 0
        ? {
            bottom: "-387px !important",
          }
        : {
            bottom: "-151px !important",
          };
    },
    filteredCustomer() {
      if (this.search.keyword) {
        return this.customers.filter((customer) => {
          return (
            customer.id
              .toLowerCase()
              .search(this.search.keyword.toLowerCase()) >= 0
          );
        });
      } else {
        return this.customers;
      }
    },
  },
  methods: {
    onTabCustomerCard(index) {
      console.log("onTabCustomerCard: ", index);
      if (index == this.selectedIdx) {
        this.selectedIdx = -1;
        return;
      }
      this.selectedIdx = index;
    },
    onSelectedCardTapped() {
      console.log("onSelectedCardTapped");
      this.selectedIdx = -1;
    },
    iconHandler() {
      if (this.isOpen) {
        console.log("Close customer tab");
      } else {
        console.log("Open customer tab");
      }
      this.isOpen = !this.isOpen;
    },
    onReload() {
      console.log("onReload");
    },
    onCart() {
      this.$router.push("/portal/cart");
      return;
    },
    onAddCustomer() {
      this.addCustomerDialog.show = true;
      return;
    },
    onAddCustomerToList(customer) {
      console.log("add customer: ", customer);
      this.addCustomerDialog.show = false;
    },
    onAddCustomerWithForm(formData){
      console.log("add customer: ", formData);
      this.addCustomerDialog.show = false;
    }
  },
};
</script>

<style scoped>

* {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.customer-list {
  background-color: #a09edc;
  padding: 20px 0;
  bottom: 39px !important;
}
.customer-list-size {
  overflow: auto;
  /* border-radius: 10px; */
  height: 100px;
}
.cart-list-size {
  overflow: auto;
  /* border-radius: 10px; */
  height: 200px;
}
.cart-item {
  width: 100%;
}
.ctrl-btn {
  width: 50px;
  height: 50px;
  background-color: #2c2a74;
  position: absolute;
  top: -25px;
  right: 0;
  border-radius: 16px;
  z-index: -1;
}
.ctrl-btn-plus {
  width: 50px;
  height: 50px;
  background-color: #2c2a74;
  position: absolute;
  top: -25px;
  right: 50px;
  border-radius: 16px;
  z-index: -1;
}
.ctrl-btn-refresh {
  width: 50px;
  height: 50px;
  background-color: #2c2a74;
  position: absolute;
  top: -25px;
  right: 100px;
  border-radius: 16px;
  z-index: -1;
}
.ctrl-icon {
  color: white;
  font-size: 30px;
  position: absolute;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  cursor: pointer;
}
.ctrl-icon-plus {
  color: white;
  font-size: 25px;
  position: absolute;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  cursor: pointer;
}
.bg-light {
  background-color: #a09edc;
}

</style>
